export function PendingPage() {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Your account is pending approval.</h1>
        <p className="text-gray-600">Please contact support.</p>
      </div>
    </div>
  );
}
